import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { EFeatureToggles, EOrderStatusTypes } from '../../../configurations/common';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { ConfigurationFacade } from '../../../facades/configuration.facade';

@Component({
  selector: 'app-harmonized-order-status-page',
  templateUrl: './harmonized-order-status-page.component.html',
  styleUrl: './harmonized-order-status-page.component.scss',
})
export class HarmonizedOrderStatusPageComponent implements OnInit, OnDestroy {
  protected readonly EOrderStatusTypes = EOrderStatusTypes;
  protected readonly window = window;

  orderStatus: string = EOrderStatusTypes.PAYMENT_FAILED;
  isExternalQuoteCheckoutEnabled$: Observable<boolean> =
    this.configurationFacade.isFeatureEnabled(EFeatureToggles.EXTERNAL_QUOTE_CHECKOUT);

  navigationButtonsSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private configurationFacade: ConfigurationFacade,
  ) {
  }

  ngOnInit(): void {
    this.checkOrderStatus();
    this._disableNavigationToPreviousRoute();
  }

  /**
   * Disable the navigation to the previous route.
   * This is done by pushing the current route to the history stack and subscribing to the popstate event.
   */
  private _disableNavigationToPreviousRoute(): void {
    history.pushState(null, null, location.href);

    this.navigationButtonsSubscription = fromEvent(window, 'popstate').subscribe(_ => {
      history.pushState(null, null, location.href);
      this.configurationFacade.appendNotification({
        type: 'warning',
        title: 'error.title-you-cannot-to-navigate-back',
        messages: [{
          key: 'error-404.prohibited-action',
        }],
      });
    });
  }

  /**
   * Check if there is a order status state in the query params.
   * Possible states are defined in EOrderStatusTypes.
   * In case, the order status state is not valid, it will be set to EOrderStatusTypes.PAYMENT_FAILED (default value).
   */
  checkOrderStatus(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const failure = params['state'];
      if (failure && Object.values(EOrderStatusTypes).includes(failure)) {
        this.orderStatus = failure;
      } else {
        this.orderStatus = EOrderStatusTypes.PAYMENT_FAILED;
        this.router.navigate([], {
          queryParams: {state: this.orderStatus},
          queryParamsHandling: 'merge', // Keeps other existing query params
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.navigationButtonsSubscription.unsubscribe();
  }
}
